import { render, staticRenderFns } from "./DishStatisticFragment.vue?vue&type=template&id=071b6590&scoped=true&"
import script from "./DishStatisticFragment.vue?vue&type=script&lang=js&"
export * from "./DishStatisticFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b6590",
  null
  
)

export default component.exports